const seriesArray = [
  {
    type: "area",
    name: "Net imports",
    color: "#991A2A",
    data: [],
    stack: "positive",
    fillOpacity: 0.2,
  },
  {
    type: "area",
    name: "DSR",
    color: "#D9A7E9",
    data: [],
    stack: "positive",
    fillOpacity: 0.9,
  },
  {
    type: "area",
    name: "Hydrogen",
    color: "#13CE74",
    data: [],
    stack: "positive",
    fillOpacity: 0.9,
  },
  {
    type: "area",
    name: "Other RES",
    color: "#0E8D4F",
    data: [],
    stack: "positive",
    fillOpacity: 0.9,
  },
  {
    type: "area",
    name: "Battery",
    color: "#F6EB81",
    data: [],
    stack: "positive",
    fillOpacity: 0.9,
  },
  {
    type: "area",
    name: "Solar",
    color: "#FFC913",
    data: [],
    stack: "positive",
    fillOpacity: 0.9,
  },
  {
    type: "area",
    name: "Offshore wind",
    color: "#1C82C5",
    data: [],
    stack: "positive",
    fillOpacity: 0.9,
  },
  {
    type: "area",
    name: "Onshore wind",
    color: "#59B4E8",
    data: [],
    stack: "positive",
    fillOpacity: 0.9,
  },
  {
    type: "area",
    name: "Pumped storage",
    color: "#5FE3DC",
    data: [],
    stack: "positive",
    fillOpacity: 0.9,
  },
  {
    type: "area",
    name: "Hydro",
    color: "#22c7b6",
    data: [],
    stack: "positive",
    fillOpacity: 0.9,
  },
  {
    type: "area",
    name: "Nuclear",
    color: "#A469CF",
    data: [],
    stack: "positive",
    fillOpacity: 0.9,
  },
  {
    type: "area",
    name: "Biomass",
    color: "#D64248",
    data: [],
    stack: "positive",
    fillOpacity: 0.9,
  },
  {
    type: "area",
    name: "Gas CCS",
    color: "#F6AF7F",
    data: [],
    stack: "positive",
    fillOpacity: 0.9,
  },
  {
    type: "area",
    name: "Gas peaker",
    color: "#C5C5C5",
    data: [],
    stack: "positive",
    fillOpacity: 0.9,
  },
  {
    type: "area",
    name: "Baseload gas",
    color: "#7A7A7A",
    data: [],
    stack: "positive",
    fillOpacity: 0.9,
  },
  {
    type: "area",
    name: "Oil",
    color: "#FF8481",
    data: [],
    stack: "positive",
    fillOpacity: 0.9,
  },
  {
    type: "area",
    name: "Coal",
    color: "#2B2B2B",
    data: [],
    stack: "positive",
    fillOpacity: 0.9,
  },
  {
    type: "area",
    name: "Net exports",
    color: "#991A2A",
    data: [],
    stack: "negative",
    fillOpacity: 0.2,
  },

  { name: "Demand", color: "red", data: [], type: "line", fillOpacity: 0.9 },
];

const transformData = (responseData) => {
  let transformedData = [];

  seriesArray.forEach((series) => {
    let data = [];
    responseData.forEach((row) => {
      if (row.technology === series.name) {
        data.push({
          x: row.year,
          y: parseFloat(row.value.toFixed(2)),
        });
      }
    });

    const summedData = Array.from(
      data.reduce((m, { x, y }) => m.set(x, (m.get(x) || 0) + y), new Map()),
      ([x, y]) => ({ x, y })
    );

    transformedData.push({
      name: series.name,
      color: series.color,
      data: summedData,
      type: series.type,
      stack: series.stack,
      fillOpacity: series.fillOpacity,
    });
  });

  return transformedData;
};

export default transformData;
